import { render, staticRenderFns } from "./DocumentProcessing.vue?vue&type=template&id=560d9510&scoped=true&"
import script from "./DocumentProcessing.vue?vue&type=script&lang=js&"
export * from "./DocumentProcessing.vue?vue&type=script&lang=js&"
import style0 from "./DocumentProcessing.vue?vue&type=style&index=0&id=560d9510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560d9510",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('560d9510')) {
      api.createRecord('560d9510', component.options)
    } else {
      api.reload('560d9510', component.options)
    }
    module.hot.accept("./DocumentProcessing.vue?vue&type=template&id=560d9510&scoped=true&", function () {
      api.rerender('560d9510', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/60100003-2/components/DocumentProcessing.vue"
export default component.exports